import { LoginResponse } from '@technologyfromsage/persona-padlock';

import { PersonaProfile, PersonaUserProfile } from './persona-profile';
import { User } from './user';

export class PersonaUser implements User {
  kind: 'persona';
  accessToken: string;
  refreshToken?: string;
  activePid: string;
  guid: string;
  isAnonymous = false;
  profile: PersonaUserProfile | undefined;
  scopes: string[];

  constructor(private loginResponse: PersonaProfile) {
    this.accessToken = this.loginResponse.oauth.access_token;
    this.refreshToken = this.loginResponse.oauth.refresh_token;
    this.activePid = this.loginResponse.active_pid;
    this.guid = this.loginResponse.guid;
    this.profile = this.loginResponse.profile;
    this.scopes = this.loginResponse.oauth.scope;
  }

  get fullName(): string | undefined {
    const { first_name = undefined, surname = undefined } = this.profile || {};

    if (first_name && surname) {
      return `${first_name} ${surname}`;
    }

    return undefined;
  }

  cloneWithProfile(profile: PersonaUserProfile): PersonaUser {
    const updatedUser = new PersonaUser(this.loginResponse);
    updatedUser.profile = profile;
    return updatedUser;
  }
}

export const createPersonaUserFromPkceLogin = (
  loginResponse: LoginResponse,
): PersonaUser =>
  new PersonaUser({
    guid: loginResponse.persona_guid,
    oauth: {
      access_token: loginResponse.access_token,
      refresh_token: loginResponse.refresh_token,
      scope: loginResponse.persona_scopes,
      token_type: 'bearer',
    },
    profile: loginResponse.persona_profile,
    active_pid: loginResponse.active_pid,
  });

export const isPersonaUser = (user: User): user is PersonaUser =>
  user && 'isAnonymous' in user && user.isAnonymous === false;
